// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YnmF","name":"Header_name__3Hw3b","birthday":"Header_birthday__1Xo1z","skeleton":"Header_skeleton__3rMWK"};